export default __webpack_public_path__ + "static/media/ads-web-2.f52367fd.gif";